import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45379192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-15" }
const _hoisted_2 = { key: "emptyResult" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCollage = _resolveComponent("ProductCollage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_TransitionGroup, {
      name: "o-anim-fade-300",
      tag: "div",
      class: "wishlists"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedList, (list) => {
          return (_openBlock(), _createElementBlock("article", {
            key: list.id,
            class: "wishlist"
          }, [
            _createVNode(_component_ProductCollage, {
              variants: list.skus
            }, null, 8, ["variants"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h4", null, _toDisplayString(list.name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.items, [list.numberOfProducts])), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.labels.createDate) + ": " + _toDisplayString(_ctx.formatDate(list.createDateTime)), 1)
            ]),
            _createVNode(_component_router_link, {
              to: _ctx.getDetailsUrl(list.id),
              title: _ctx.labels.viewList,
              class: "wishlist__link"
            }, null, 8, ["to", "title"])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { "enter-active-class": "animated fadeIn u-anim-dur-300 u-anim-delay-300" }, {
      default: _withCtx(() => [
        (_ctx.isEmptyResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.emptyResultText), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}